exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box[data-v-381c15b2]{height:260px}.box[data-v-381c15b2] .k-textarea{height:260px!important;resize:none}", ""]);

// exports
